import { Route } from '@angular/router';

export const awardsRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@rma/dashboard/awards/overview'),
  },
  {
    path: 'checkout',
    loadChildren: () => import('@rma/dashboard/awards/shop'),
  },
];
